import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-languageschool',
  imports: [],
  templateUrl: './languageschool.component.html',
  styleUrl: './languageschool.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageschoolComponent {

}
